import { render, staticRenderFns } from "./aiUpload.vue?vue&type=template&id=2c067081&scoped=true&"
import script from "./aiUpload.vue?vue&type=script&lang=js&"
export * from "./aiUpload.vue?vue&type=script&lang=js&"
import style0 from "./aiUpload.vue?vue&type=style&index=0&id=2c067081&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c067081",
  null
  
)

export default component.exports